const initOrder = () => {
    

    $('#btnProductOrder').click(e => {
        $('.transparent-fill').show();
        $('.sort-wrapper .sort-container').css('display', 'flex');
        $('body').css('overflow', 'hidden');
        e.preventDefault();
    })
    $('.sorting-wrapper-close').click(e => {
        $('.transparent-fill').hide();
        $('.sort-wrapper .sort-container').css('display', 'none');
        $('body').css('overflow', 'auto');
        e.preventDefault();
    })
    $('span.sort-value').click(e => {
        var inactive = $('.sorting-wrapper').hasClass('inactive');
        $('.sorting-wrapper').toggleClass('inactive');
        if (inactive) {
            $("body").one("click", () => {
                $('.sorting-wrapper').toggleClass('inactive');
            });   
        }
        e.preventDefault();
        e.stopPropagation();
    })
    $('.sorting-wrapper').click(e => {
        e.stopPropagation();
    })
};

export {
    initOrder
};
